export default "__VITE_ASSET__3b4d68f3__"